import { Redirect } from "react-router-dom";

export const Checkout = () => {
  return <Redirect to="/settings/billing" />;
};

export default Checkout;
